import type { ReactNode } from 'react'
import type { CSSProperties } from 'react'
import 'src/styles/components/common/card.less'

type Props = {
  children: ReactNode,
  className?: string,
  style?: CSSProperties,
}

const Card = (props: Props) => {
  return (
    <div className={`card ${props.className}`} style={props.style}>
      {props.children}
    </div>
  )
}

export default Card